import {
    disabledMenuButtonHandler,
    playEventHandler,
    resetMenuButtonClickHandlers,
    tournamentMenuButtonHandler
} from "./game-menu.js";
import {showDialogPersonGraphic, showTalentDialogPageGraphic} from "./graphics.js";
import {getCurrentGame} from "../modules/helpers.js";
import {getPointsHtml, makeGameRequest, runAnnualTournamentSelectionsSearch} from "./ui-helpers.js";
import {getAnnualTournamentSelectionItemHtml, loadHomePage} from "./home-page.js";
import {globals} from "../modules/globals.js";
import {getTournamentInjuryHtml} from "./matches.js";
import {
    addAnnualTournamentCompanyBribeView,
    getAnnualTournamentAvailableSelections,
    replaceAnnualTournamentCompanyInjuredParticipant,
    selectAnnualTournamentCompanyParticipants,
    startAnnualTournamentView,
    updateAnnualTournamentCompanyStatusView
} from "../modules/annualTournament.js";

/* Annual Tournament */

function showNPCDialog(dialogData) {
    $('#npc-dialog').fadeIn('slow');

    // Disable menu buttons if not at match
    if (!$('#progress-segment-button').is(":visible")) {
        resetMenuButtonClickHandlers(tournamentMenuButtonHandler);
    }

    // Show name and information
    let dialogPersonInformation = dialogData['information'];
    $('.npc-dialog-person-name').text(dialogPersonInformation['name']);
    $('.npc-dialog-person-role').html('<div>President</div><div class="medium-grey">The Grand Invitational</div>').show();
    $('.npc-dialog-person-information').show();

    // Show graphic
    let el = $('.npc-dialog-person-graphic');
    showTalentDialogPageGraphic(el, [dialogPersonInformation['graphic']], false, true);

    // Show dialog
    goThroughNPCDialog(dialogData['dialogs'], 0);
}

function goThroughNPCDialog(dialogs, dialogIndex) {
    let selectedChoice;
    let dialog = dialogs[dialogIndex];
    let currentChoices = dialog['choices'];

    // Show dialog
    let textIndex = 0;
    let currentDialogText = dialog['text'];
    showNPCDialogText(currentDialogText[textIndex]);

    // Check to show dialog choices or continue button
    processNPCNextDialogText(textIndex, currentDialogText, currentChoices);

    // Show/hide end button
    if (dialog && dialog['action'] === 'startEvent') {
        $('.npc-dialog-end-button-container').show();
    }
    else {
        $('.npc-dialog-end-button-container').hide();
    }

    // Choice click
    $(document).off('click', '.npc-dialog-text');
    $(document).on('click', '.npc-dialog-text', async function() {
        // Get selected choice
        let selectedChoiceIndex = $('.npc-dialog-text').index($(this));
        selectedChoice = currentChoices[selectedChoiceIndex];

        // Mark choice as selected
        selectedChoice['selected'] = true;

        // Run choice's action if present
        if (selectedChoice['action']) {
            let replyText = (selectedChoice['reply']) ? selectedChoice['reply']['text'] : '';
            await performNPCAction(selectedChoice['action'], replyText);
        }
        else {
            // Get next choices if present
            if (selectedChoice['reply']['choices']) {
                currentChoices = selectedChoice['reply']['choices']
            }
            // Otherwise go back to main choices
            else {
                currentChoices = dialog['choices']
            }

            // Show dialog
            textIndex = 0;
            currentDialogText = selectedChoice['reply']['text'];
            showNPCDialogText(currentDialogText[textIndex]);
            processNPCNextDialogText(textIndex, currentDialogText, currentChoices,
                selectedChoice['reply']['goToNextDialog']);
        }
    });

    // Continue dialog click
    $(document).off('click', '.npc-dialog-continue-button');
    $(document).on('click', '.npc-dialog-continue-button', function() {
        let goToNextDialog = selectedChoice && selectedChoice['reply']['goToNextDialog'];
        // Go to next dialog
        if (goToNextDialog && textIndex >= currentDialogText.length - 1) {
            dialogIndex++;
            goThroughNPCDialog(dialogs, dialogIndex);
        }
        // Go to next text
        else {
            textIndex++;
            showNPCDialogText(currentDialogText[textIndex]);
            processNPCNextDialogText(textIndex, currentDialogText, currentChoices, goToNextDialog);
        }
    });

    // End dialog click
    $(document).off('click', '.npc-dialog-end-button');
    $(document).on('click', '.npc-dialog-end-button', async function() {
        let startEvent = (dialog && dialog['action'] === 'startEvent');
        if (!startEvent) {
            $('#npc-dialog').hide();
        }

        // Enable menu buttons if not at match
        if (!$('#progress-segment-button').is(":visible")) {
            resetMenuButtonClickHandlers('default')
        }

        // Play event if bracket created
        if (startEvent) {
            await playEventHandler(false, true)
        }
        else {
            // Enable continue button if at match
            if ($('#progress-segment-button').is(":visible")) {
                $('#progress-segment-button').removeClass('disabled')
            }
            // Otherwise load home page
            else {
                await loadHomePage(await getCurrentGame());
            }
        }
    });

    // Click selection item
    $(document).off('click', '.annual-tournament-selection-item');
    $(document).on('click', '.annual-tournament-selection-item', function() {
        if ($(this).hasClass('unavailable')) {
            return;
        }
        let selectionsAvailable = parseInt($('.annual-tournament-selections-info').data('value'));
        let selectionsSelected = $('.annual-tournament-selection-item.selected');

        // Select
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected')
        }
        // If at selections limit, don't select
        else {
            if (selectionsSelected.length >= selectionsAvailable) {
                let entriesWord = (selectionsAvailable === 1) ? 'entry' : 'entries';
                notie.alert({type: 4, text: 'You can\'t select more than {0} {1}'.format(selectionsAvailable, entriesWord), stay: true});
                return;
            }
            $(this).addClass('selected')
        }

        // Update selections available
        selectionsSelected = $('.annual-tournament-selection-item.selected').length;
        $('.annual-tournament-selections-info').html('<span class="annual-tournament-selections-number margin-right-2">' +
            '{0} / {1}</span> Selected'.format(selectionsSelected, selectionsAvailable));

        // Turn green if selections complete
        if (selectionsSelected === selectionsAvailable) {
            $('.annual-tournament-selections-number').addClass('green')
        }
        else {
            $('.annual-tournament-selections-number').removeClass('green')
        }
    });

    // Confirm selections
    $(".annual-tournament-selections-container").off('click', '.annual-tournament-confirm-selections-button');
    $(".annual-tournament-selections-container").on('click', '.annual-tournament-confirm-selections-button', function() {
        // Check if all selections selected
        let selectionsAvailable = parseInt($('.annual-tournament-selections-info').data('value'));
        let selectionsSelected = $('.annual-tournament-selection-item.selected').length;
        let confirmText = 'Are you sure?';
        if (selectionsSelected < selectionsAvailable) {
            confirmText = 'You haven\'t selected all the entries available to you. Are you sure you want to continue?'
        }
        notie.confirm({
            text: confirmText,
            submitCallback: async function () {
                let injuryReplacement = $('.annual-tournament-selections-container').data('injuryReplacement');
                if (injuryReplacement) {
                    await performNPCAction('confirmReplacement')
                }
                else {
                    await performNPCAction('confirmEntries')
                }
            }
        });

    });

    // Back button
    $(".annual-tournament-selections-container").off('click', '.annual-tournament-back-button');
    $(".annual-tournament-selections-container").on('click', '.annual-tournament-back-button', function() {
        $('.annual-tournament-selections-container').fadeOut('fast', function () {
            $('#npc-dialog').fadeIn('fast');
            // Go back to main choices
            goThroughNPCDialog(dialogs, dialogIndex);
        });
    });

    // Search selections
    $(".annual-tournament-selections-container").off('input', '.annual-tournament-selections-search-input');
    $(".annual-tournament-selections-container").on('input', '.annual-tournament-selections-search-input', function() {
        runAnnualTournamentSelectionsSearch();
    });

    async function performNPCAction(action, dialogText) {
        if (action === 'acceptInvitation' || action === 'declineInvitation') {
            await makeGameRequest(updateAnnualTournamentCompanyStatusView, {action},
                showUpdateAnnualTournamentCompanyStatusData, {}, false);
        }
        else if (action === 'selectEntries') {
            await makeGameRequest(getAnnualTournamentAvailableSelections, {},
                showGetAnnualTournamentAvailableSelectionsData, {}, false);
        }
        else if (action === 'bribePresident') {
            await makeGameRequest(addAnnualTournamentCompanyBribeView, {action},
                showAddAnnualTournamentCompanyBribeData, {}, false);
        }
        else if (action === 'confirmEntries') {
            let participantUids = Array.from($('.annual-tournament-selection-item.selected'), function (el) {
                return parseInt($(el).attr('data-uid'))
            });
            await makeGameRequest(selectAnnualTournamentCompanyParticipants,
                {participantUids}, showSelectAnnualTournamentCompanyParticipantsData, {}, false);
        }
        else if (action === 'startTournament') {
            await makeGameRequest(startAnnualTournamentView, {}, showStartAnnualTournamentData, {}, false);
        }
        else if (action === 'selectReplacement') {
            await makeGameRequest(getAnnualTournamentAvailableSelections, {injuryReplacement: true},
                showGetAnnualTournamentAvailableSelectionsData, {injuryReplacement: true}, false);
        }
        else if (action === 'confirmReplacement') {
            let replacementUid = parseInt($('.annual-tournament-selection-item.selected').attr('data-uid'));
            await makeGameRequest(replaceAnnualTournamentCompanyInjuredParticipant, {replacementUid},
                showReplaceAnnualTournamentCompanyInjuredParticipantData, {}, false);
        }

        function showUpdateAnnualTournamentCompanyStatusData({data} = {}) {
            if (!data['error']) {
                showNPCDialogEnd(dialogText);
            } else {
                if (data['error'] === 'tournament-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'The annual tournament could not be found. Please try again.'
                    });
                }
            }
        }

        function showGetAnnualTournamentAvailableSelectionsData({data, injuryReplacement = false} = {}) {
            // Add selections
            let html = '';
            data['selections'].forEach(function(selection) {
                html += getAnnualTournamentSelectionItemHtml(selection)
            });
            if (data['selections'].length <= 0) {
                html += '<div class="no-annual-tournament-selections-search-results inner-box-item ' +
                    'annual-tournament-selection-item unavailable light-grey">No Talent Present</div>'
            }
            $('.annual-tournament-selection-items-container').html(html).show().scrollTop(0);

            // Add selections text
            let selectionsAvailable = data['numberOfEntries'];
            $('.annual-tournament-selections-info').data('value', selectionsAvailable);
            $('.annual-tournament-selections-info').html('<span class="annual-tournament-selections-number ' +
                'margin-right-2">0 / {0}</span> Selected'.format(selectionsAvailable));

            // Show confirm selections container
            $('#npc-dialog').fadeOut('fast', function () {
                $('.annual-tournament-selections-container').fadeIn('fast');
                $('.annual-tournament-selections-container').data('injuryReplacement', injuryReplacement);
                $('.annual-tournament-selection-items-container').scrollTop(0);
                $('.annual-tournament-selections-search-input').val('');
            });
        }

        function showAddAnnualTournamentCompanyBribeData({data} = {}) {
            if (!data['error']) {
                // If success, remove bribe choice
                if (data['success']) {
                    dialog['choices'].pop();
                    // Update points
                    let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
                    $(".points-number").html(pointsHtml);
                }

                // Show bribe dialog reply, go back to main choices
                currentChoices = dialog['choices'];
                textIndex = 0;
                currentDialogText = data['dialog'];
                showNPCDialogText(currentDialogText[textIndex]);
                processNPCNextDialogText(textIndex, currentDialogText, currentChoices);

            } else {
                if (data['error'] === 'tournament-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'The annual tournament could not be found. Please try again.'
                    });
                }
            }
        }

        function showSelectAnnualTournamentCompanyParticipantsData({data} = {}) {
            if (!data['error']) {
                $('.annual-tournament-selections-container').fadeOut('fast', function () {
                    $('#npc-dialog').fadeIn('fast');
                    showNPCDialogEnd(data['dialog']);
                    // Update points
                    let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
                    $(".points-number").html(pointsHtml);
                });
            }
            else {
                if (data['error'] === 'tournament-not-found') {
                    notie.alert({type: 3, text: 'The annual tournament could not be found. Please try again.'});
                }
                else if (data['error'] === 'too-many-entries') {
                    notie.alert({type: 3, text: 'You have selected more entries than are available to you.'});
                }
            }
        }

        function showStartAnnualTournamentData({data} = {}) {
            if (!data['error']) {
                // If success, show reply and start event
                if (data['success']) {
                    showNPCDialogEnd(data['dialog'])
                }
                // Otherwise show reply, go back to main choices
                else {
                    currentChoices = dialog['choices'];
                    textIndex = 0;
                    currentDialogText = data['dialog'];
                    showNPCDialogText(currentDialogText[textIndex]);
                    processNPCNextDialogText(textIndex, currentDialogText, currentChoices);
                }
            } else {
                if (data['error'] === 'tournament-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'The annual tournament could not be found. Please try again.'
                    });
                }
            }
        }

        function showReplaceAnnualTournamentCompanyInjuredParticipantData({data} = {}) {
            if (!data['error']) {
                $('.annual-tournament-selections-container').fadeOut('fast', function () {
                    $('#npc-dialog').fadeIn('fast');
                    showNPCDialogEnd(data['dialog']);

                    // Add injury to event updates if at match
                    let eventUpdatesSelector = $(".event-updates-other .updates-container");
                    if (eventUpdatesSelector.length > 0) {
                        let tournamentInjuryHtml = getTournamentInjuryHtml(data['tournamentInjury']);
                        eventUpdatesSelector.prepend(
                            '<span class="display-block margin-bottom-12">' + tournamentInjuryHtml +
                            '</span>'
                        )
                        $(eventUpdatesSelector).parent().fadeIn('slow');
                    }
                });
            }
            else {
                if (data['error'] === 'tournament-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'The annual tournament could not be found. Please try again.'
                    });
                } else if (data['error'] === 'replacement-not-found') {
                    notie.alert({type: 3, text: 'The selected replacement could not be found. Please try again.'});
                }
            }
        }
    }
}

function processNPCNextDialogText(textIndex, currentDialogText, currentChoices, goToNextDialog) {
    $('.npc-dialog-continue-button-container').hide();

    // If final text and not end of dialog, show this dialog's choices
    if (textIndex >= currentDialogText.length - 1 && !goToNextDialog) {
        showNPCDialogChoices(currentChoices);
        $('.npc-dialog-continue-button-container').hide();
    }
    // Otherwise show continue button to go to next text/dialog
    else {
        setTimeout(function () {
            $('.npc-dialog-continue-button-container').fadeIn('slow')
        }, 250);
        $('.npc-dialog-choices-container').hide();
    }
}

function showNPCDialogText(text) {
    let dialogContentElement = $('.npc-dialog-content');

    // Show text
    dialogContentElement.html(text).hide().fadeIn();
}

function showNPCDialogChoices(choices) {
    let dialogChoicesElement = $('.npc-dialog-choices-container');

    // Show choices
    let choicesHtml = '';
    choices.forEach(function (choice) {
        let selectedClass = '';
        if (choice['selected']) {
            selectedClass = ' selected';
        }
        if (choice['highlight']) {
            selectedClass = ' ' + choice['highlight'];
        }
        choicesHtml += '<div class="dialog-choice-item npc-dialog-text' + selectedClass + '">' + choice['text'] + '</div>';
    });

    dialogChoicesElement.hide();
    if (choices.length > 0) {
        setTimeout(function () {
            dialogChoicesElement.html(choicesHtml).fadeIn('slow');
        }, 500);
    }
}

function showNPCDialogEnd(dialog) {
    // Show dialog, hide responses, show continue button
    showNPCDialogText(dialog);
    $('.npc-dialog-choices-container').hide();
    setTimeout(function () {
        $('.npc-dialog-end-button-container').fadeIn('slow');
    }, 500);
}

/* PoW */

let dialogData;

function showGetPowDialogData({data}) {
    // Load dialog
    dialogData = data;

    if (dialogData['Hank Hughes'] && dialogData['Hank Hughes']['storyPosition'] === 'introduction') {
        // Show introduction dialog
        selectDialogPerson([dialogData['Hank Hughes']]);
    }
    else {
        // Show person choices once dialog is loaded
        $('#select-dialog-person').trigger('click');
    }

    $('.dialog-header').show();
    $('#pow-dialog').fadeIn('slow');
}

function selectDialogPerson(dialogsData, isReactionDialog) {
    let dialog = dialogsData[0];

    // Show name and information
    let dialogPersonInformation = dialog['information'];
    $('.dialog-person-name').text(dialogPersonInformation['name']);

    if (dialogPersonInformation['producer']) {
        $('.dialog-person-superstar-information').hide();
        $('.dialog-person-role').html('<div>Boss</div><div class="medium-grey">Producer</div>').show();
    } else {
        $('.dialog-person-popularity').text(dialogPersonInformation['popularity']);
        $('.dialog-person-overness').text(dialogPersonInformation['overness'] + '%');

        let charisma = dialogPersonInformation['charisma'];
        let originalCharisma = (dialogPersonInformation['hot']) ? charisma - 1 : charisma;
        let charismaHtml = '<i class="fa fa-star"></i>'.repeat(originalCharisma);
        if (dialogPersonInformation['hot']) {
            charismaHtml += '<i class="fa fa-star hot-color"></i>'
        }
        if (charisma < 3) {
            charismaHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - charisma);
        }
        $('.dialog-person-charisma').html(charismaHtml);

        let workrate = dialogPersonInformation['workrate'];
        let originalWorkrate = (dialogPersonInformation['hot']) ? workrate - 1 : workrate;
        let workrateHtml = '<i class="fa fa-star"></i>'.repeat(originalWorkrate);
        if (dialogPersonInformation['hot']) {
            workrateHtml += '<i class="fa fa-star hot-color"></i>'
        }
        if (workrate < 3) {
            workrateHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - workrate);
        }
        $('.dialog-person-workrate').html(workrateHtml);

        if (dialogPersonInformation['hot']) {
            $('.dialog-person-workrate').addClass('hot-color');
            $('.dialog-person-charisma').addClass('hot-color');
        }
        else {
            $('.dialog-person-workrate').removeClass('hot-color');
            $('.dialog-person-charisma').removeClass('hot-color');
        }

        $('.dialog-person-superstar-information').show();
        $('.dialog-person-role').hide();
    }

    $('.dialog-person-information').show();

    // Show graphic
    let el = $('.dialog-person-graphic');
    showDialogPersonGraphic([dialogPersonInformation['graphic']], el);

    // Show dialog
    goThroughChoicesDialog(dialogsData, 0, isReactionDialog);
}

function goThroughChoicesDialog(dialogsData, dialogIndex, isReactionDialog) {
    let dialog = dialogsData[dialogIndex];

    // Get main dialog choices
    let currentChoices = dialog['choices'];

    // Show dialog
    let textIndex = 0;
    let currentDialogText = dialog['text'];
    showDialogText(currentDialogText[textIndex]);

    // Check to show dialog choices or continue button
    processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog);

    // Choice click
    $(document).off('click', '.dialog-text');
    $(document).on("click", '.dialog-text', function() {

        // Get selected choice
        let selectedChoiceIndex = $('.dialog-text').index($(this));
        let selectedChoice = currentChoices[selectedChoiceIndex];

        // Mark choice as selected
        selectedChoice['selected'] = true;

        if (selectedChoice['reply']['choices'].length > 0 || isReactionDialog || selectedChoice['reply']['end_conversation']) {
            // Get next choices if present and direct dialog
            currentChoices = selectedChoice['reply']['choices']
        }
        else {
            // Otherwise go back to main choices
            currentChoices = dialog['choices']
        }

        // Show dialog
        textIndex = 0;
        currentDialogText = selectedChoice['reply']['text'];
        showDialogText(currentDialogText[textIndex]);

        processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog);

        if (selectedChoice['reply']['end_conversation']) {
            setTimeout(function () {
                $('#select-dialog-person').trigger('click');
            }, 1300);
        }
    });

    // Continue dialog click
    $(document).off('click', '.pow-dialog-continue-button');
    $(document).on("click", '.pow-dialog-continue-button', function() {
        // Show next dialog text
        textIndex++;
        showDialogText(currentDialogText[textIndex]);
        processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog);
    });

    // Next dialog click
    $(document).off('click', '.pow-dialog-next-button');
    $(document).on("click", '.pow-dialog-next-button', function() {
        dialogIndex++;
        if (dialogsData[dialogIndex]) {
            // Get next dialog
            goThroughChoicesDialog(dialogsData, dialogIndex, isReactionDialog)
        }
        else {
            // If no more dialogs, hide dialog box
            $('#pow-dialog').fadeOut(function () {
                // Enable menu buttons if not at end event and not failure ending
                if (!$('#continue-container').is(":visible")) {
                    if (!globals.game.powStoryFailureEnding) {
                        resetMenuButtonClickHandlers('default');
                    }
                    $('#dashboard-container').show();
                    $('#view-dashboard-menu-button').addClass('selected');
                }
            });
        }
    });
}

function showDialogText(text) {
    let dialogContentElement = $('.pow-dialog-content');
    dialogContentElement.html(text).hide().fadeIn();
}

function processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog) {
    $('.pow-dialog-continue-button-container').hide();
    $('.pow-dialog-next-button-container').hide();

    // If final text, show dialog choices
    if (textIndex >= currentDialogText.length - 1) {
        showDialogChoices(currentChoices);
        $('.pow-dialog-continue-button-container').hide();

        // Check to show next dialog button
        checkToShowNextDialogButton(currentChoices, isReactionDialog);
    }
    // Otherwise show continue button to go to next text
    else {
        setTimeout(function () {
            $('.pow-dialog-continue-button-container').fadeIn('slow')
        }, 250);
        $('.dialog-choices-container').hide();
    }
}

function checkToShowNextDialogButton(choices, isReactionDialog) {
    // Show 'next' button if reaction dialog and no more choices
    if (choices.length <= 0 && isReactionDialog) {
        setTimeout(function () {
            $('.pow-dialog-next-button-container').fadeIn('slow')
        }, 250);
    }
}

function showDialogChoices(choices) {
    let dialogChoicesElement = $('.dialog-choices-container');

    // Show choices
    let choicesHtml = '';
    choices.forEach(function (choice) {
        let selectedClass = '';
        if (choice['selected']) {
            selectedClass = ' selected';
        }
        choicesHtml += '<div class="dialog-choice-item dialog-text' + selectedClass + '">' + choice['text'] + '</div>';
    });

    dialogChoicesElement.hide();
    if (choices.length > 0) {
        setTimeout(function () {
            dialogChoicesElement.html(choicesHtml).fadeIn('slow');
        }, 500);
    }
}

function showReactionDialog(dialogsData) {
    $('#pow-dialog').fadeIn('slow');
    $('.dialog-header').hide();

    // Disable menu buttons if not at end event
    if (!$('#continue-container').is(":visible")) {
        resetMenuButtonClickHandlers(disabledMenuButtonHandler)
    }

    selectDialogPerson(dialogsData, true);
}

function dialogPersonChoiceHandler(name) {
    // Get person's data
    let personDialogData = dialogData[name];

    if (!personDialogData) {
        notie.alert({type: 3, text: "{0} is not available to talk to.".format(name)});
        return false;
    }

    selectDialogPerson([personDialogData]);
}

function selectDialogPersonHandler() {
    $('.pow-dialog-content').hide();
    $('.dialog-person-information').hide();
    $('.pow-dialog-next-button-container').hide();
    $('.pow-dialog-continue-button-container').hide();

    // Get people choices from dialogData
    let dialogPeopleArray = ['Hank Hughes', 'Lady Julia', 'Violet', 'Zora', 'Natasha Ali'];
    let sidePeopleArray = [];
    // Add side character choices after introduction
    if (dialogData['Hank Hughes'] && dialogData['Hank Hughes']['storyPosition'] !== 'introduction') {
        sidePeopleArray = ['Merry Martha', 'Lora the Lioness', 'Fortuna', 'Scarlet', 'Joan of Narcs'];
    }

    // Get people choices html
    let personChoicesHtml = '';
    let sidePersonChoicesHtml = '';
    dialogPeopleArray.concat(sidePeopleArray).forEach(function (person) {
        // Show opaque item if not available
        let dialogChoiceClass = (!dialogData[person]) ? ' selected' : '';
        let dialogChoiceHtml = '<div class="dialog-person-choice dialog-choice-item' + dialogChoiceClass + '">' + person + '</div>';
        if (dialogPeopleArray.indexOf(person) >= 0) {
            personChoicesHtml += dialogChoiceHtml
        }
        else {
            sidePersonChoicesHtml += dialogChoiceHtml
        }
    });

    // Add people choices
    $('.dialog-choices-container').html(
        '<div class="column-left">' + personChoicesHtml + '</div>' +
        '<div class="column-right">' + sidePersonChoicesHtml + '</div>' +
        '<div class="clear"></div>'
    ).hide().fadeIn();
}

export {showNPCDialog, showGetPowDialogData, showReactionDialog, dialogPersonChoiceHandler, selectDialogPersonHandler}